import config from '../../../config';

export const SIGNUP_URL = `${config.signUpUrl}`;
export const START_FREE_PACKAGES = {
  e: 'sg.ei.free-100.v1',
  mc: 'sg.mc.free.v1',
};
